@use "styles/mixins/_rem.scss" as rem;

.image-preview-shell {
  position: absolute;
  width: rem.torem(92px);
  z-index: 0;
}

.image-preview-home-preview {
  position: absolute;
  top: rem.torem(86.75px);
  left: rem.torem(5.88px);
  width: rem.torem(35.8px);
  background-color: var(--color-background-default);
}
